
(function() {
  var result = { translations: { "da": { "i18n": { "duration": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t.", "hoursAndMinutes": "{{ hours }}t. {{ minutes }}min.", "days": "{{ days }}dg", "shortForm": { "seconds": "{{ seconds }}sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t", "days": "{{ days }}dg", "hoursAndMinutes": "{{ hours }}t {{ minutes }}min." } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, lokal {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "da": "static-7.932"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.932",
    "ar-eg": "static-7.932",
    "bg": "static-7.932",
    "bn": "static-7.932",
    "ca-es": "static-7.932",
    "cs": "static-7.932",
    "da": "static-7.932",
    "de": "static-7.932",
    "el": "static-7.932",
    "en-gb": "static-7.932",
    "en": "static-7.932",
    "es-mx": "static-7.932",
    "es": "static-7.932",
    "fi": "static-7.932",
    "fr-ca": "static-7.932",
    "fr": "static-7.932",
    "he-il": "static-7.932",
    "hr": "static-7.932",
    "hu": "static-7.932",
    "id": "static-7.932",
    "it": "static-7.932",
    "ja": "static-7.932",
    "ko": "static-7.932",
    "lt": "static-7.932",
    "ms": "static-7.932",
    "nl": "static-7.932",
    "no": "static-7.932",
    "pl": "static-7.932",
    "pt-br": "static-7.932",
    "pt-pt": "static-7.932",
    "ro": "static-7.932",
    "ru": "static-7.932",
    "sk": "static-7.932",
    "sl": "static-7.932",
    "sv": "static-7.932",
    "th": "static-7.932",
    "tl": "static-7.932",
    "tr": "static-7.932",
    "uk": "static-7.932",
    "vi": "static-7.932",
    "x-pseudo": "static-7.932",
    "zh-cn": "static-7.932",
    "zh-hk": "static-7.932",
    "zh-tw": "static-7.932"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:da', {version: 'static-7.932'}); }
})();


